import React, { PureComponent } from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import { formElement } from '../../../lib/styles';
import IconArrow from 'material-ui/svg-icons/navigation/arrow-drop-down';

const styles = {
	style: {
		width: '100%',
		marginTop: 11,
		fontSize: 14,
		height: 56,
		lineHeight: '56px',
	},
	hintStyle: {
		bottom: -5,
		fontSize: 14,
		color: '#000',
		whiteSpace: 'nowrap',
		width: '90%',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	listStyle: {
		maxHeight: '30vh',
		overflowY: 'auto',
	},
	textFieldStyle: {
		width: '100%',
		height: 56,
		lineHeight: '56px',
	},
	inputStyle: {
		fontSize: 14,
		marginTop: 14,
		height: 34,
		paddingTop: 4,
		lineHeight: '34px',
	},
};

/**
 * Рендер меню
 * @param {array} listItems список всех значений для меню
 * @param {string} stateItem название поля для фильтра
 * @param {object} config настройки меню (лейбл и название поля для title)
 */

export class HeaderFilterDropdown extends PureComponent {
	render() {
		const { dataSource, config, value = {} } = this.props;

		const dataSourceConfig = {
			text: config.text,
			value: 'id',
		};
		return (
			<div className="header-filter--item header-filter--dropdown">
				<AutoComplete
					{...styles}
					floatingLabelText={config.label}
					floatingLabelFixed={true}
					filter={AutoComplete.fuzzyFilter}
					floatingLabelStyle={{
						...formElement.label,
						top: 19,
					}}
					menuCloseDelay={50}
					searchText=""
					hintText={value.hintText}
					openOnFocus={true}
					dataSource={dataSource}
					dataSourceConfig={dataSourceConfig}
					onNewRequest={this.handleNewRequest}
					onUpdateInput={this.handleInput}
				/>
				<IconArrow color="#777" className="header-filter--dropdown-arrow" />
			</div>
		);
	}

	handleInput = searchText => {
		console.log(searchText);
	};

	handleNewRequest = chosenRequest => {
		const { fieldId, onValueChange } = this.props;
		onValueChange({
			[fieldId]: chosenRequest,
			hintText: chosenRequest.title ? chosenRequest.title : chosenRequest.name,
			searchText: '',
		});
	};
}



// WEBPACK FOOTER //
// src/components/media/components/header-filter-dropdown.component.jsx